(function () {
  /* eslint-disable */
  RS.Modules.SearchBox = {
    BLACK:'#000000',
    refSearchTerm: null,
    refSearchForm: null,
    refMpnSearchCheckbox: null,
    refMpnSearchCheckboxIcon: null,
    MPN_SEARCH_CHECKED: 'MPN_SEARCH_CHECKED',
    REDIRECT: 'Redirect',

    check: function (event) {
      // Remove * sign from the search box
      var _searchValue = (RS.Modules.SearchBox.refSearchTerm.val()).replace(/\*/g, '');

      if (_searchValue.length < RS.Modules.SearchBox.minLength() || _searchValue === searchConfig.searchDefaultText) {
        // change this to bootstrap modal in future
        window.alert(RS.Modules.SearchBox.searchLengthMessage());
        RS.Modules.SearchBox.refSearchTerm.focus();
        event.preventDefault();
      } else {
        RS.Modules.Analytics.addDeferredSearchEvent('header', _searchValue);
      }
    },

    minLength: function () {
      return (typeof(searchConfig.searchTermMinLength) !== 'undefined') ? searchConfig.searchTermMinLength : 2;
    },

    repopulateSearchTerm: function() {
      var digitalData = (((rs || {}).web || {}).digitalData || {});
      var searchTerm = digitalData.search_keyword || null;
      var searchTermCorrected = digitalData.search_keyword_spell_corrected || null;
      var searchResponseAction = digitalData.search_response_action || null;

      if (searchResponseAction === RS.Modules.SearchBox.REDIRECT) {
        return;
      }

      if (searchTermCorrected) {
        this.refSearchTerm.val(searchTermCorrected);
        this.refSearchTerm.css('color', RS.Modules.SearchBox.BLACK);
      } else if (searchTerm) {
        this.refSearchTerm.val(searchTerm);
        this.refSearchTerm.css('color', RS.Modules.SearchBox.BLACK);
      }
    },

    searchLengthMessage: function () {
      return (typeof(searchLengthMessage) !== 'undefined') ? searchLengthMessage : 'Please enter a value';
    },

    init: function (elmSearchForm, elmSearchTerm) {
      this.refSearchForm = $(elmSearchForm);
      this.refSearchTerm = $(elmSearchTerm);
      if (this.refSearchTerm.length > 0 && this.refSearchForm.length > 0) {
        this.refSearchForm.submit(RS.Modules.SearchBox.check);
      }
    },

    bindMpnSearchCheckboxIcon: function() {
      RS.Modules.SearchBox.refMpnSearchCheckboxIcon.click(function() {
        var toggleMpnSearchChecked = !RS.Modules.SearchBox.isMpnSearchChecked();

        // BR-858 temporaily remove the storing the MPN tick box in SessionStorage
        // RS.Utils.LocalStorage.setItemInSessionStorage(RS.Modules.SearchBox.MPN_SEARCH_CHECKED, toggleMpnSearchChecked);

        RS.Modules.SearchBox.setMpnSearchCheckbox(toggleMpnSearchChecked);
        RS.Modules.SearchBox.toggleMpnSearchCheckboxIcon();
      });
    },

    initMpnSearch: function() {
      if (RS.Modules.SearchBox.isMpnSearchEnabled()) {
        RS.Modules.SearchBox.refMpnSearchCheckbox = $('#mpnSearchCheckbox');
        RS.Modules.SearchBox.refMpnSearchCheckboxIcon = $('#mpnSearchCheckboxIcon');
        RS.Modules.SearchBox.bindMpnSearchCheckboxIcon();

        // BR-858 temporaily remove the storing the MPN tick box in SessionStorage
        // var fromSessionStorage = RS.Utils.LocalStorage.getItemFromSessionStorage(RS.Modules.SearchBox.MPN_SEARCH_CHECKED);
        // var isMpnSearchChecked = (fromSessionStorage === 'true');
        // if (isMpnSearchChecked) {
        //   RS.Modules.SearchBox.setMpnSearchCheckbox(true);
        //   RS.Modules.SearchBox.toggleMpnSearchCheckboxIcon();
        // }
      }
    },

    isMpnSearchChecked: function() {
      return RS.Modules.SearchBox.isMpnSearchEnabled() && RS.Modules.SearchBox.refMpnSearchCheckbox.is(':checked');
    },

    isMpnSearchEnabled: function() {
      return typeof window.searchConfig !== 'undefined' && typeof window.searchConfig.mpnSearchEnabled !== 'undefined' && window.searchConfig.mpnSearchEnabled;
    },

    setMpnSearchCheckbox: function(mpnSearchChecked) {
      RS.Modules.SearchBox.refMpnSearchCheckbox.prop('checked', mpnSearchChecked);
    },

    toggleMpnSearchCheckboxIcon: function() {
      RS.Modules.SearchBox.refMpnSearchCheckboxIcon.toggleClass('icon-rs_150-checkbox');
      RS.Modules.SearchBox.refMpnSearchCheckboxIcon.toggleClass('icon-rs_151-checkbox_tick');
    },
  };
}());

(function () {
  // Initalise the Check term
  RS.Modules.SearchBox.init('#searchForm', '#searchTerm');
  RS.Modules.SearchBox.initMpnSearch();
}());


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/universalheader/searchbox.js
// module id = 323
// module chunks = 5